import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { apis } from "../config/apis";
import endpoint from "../config/endpoint";
import Close from "./../assets/cancel.svg";
import { ContainerStatus } from "./Cart/Cart";
import { store_addr_details } from "../actions/orders";

const BulkPreview = ({ table, setPreview, setTable }) => {
  const stored_details = useSelector((state) => state?.orders?.storedOrder);
  const [skuRes, setSKURes] = useState([]);
  const [addedToCart, setAddedToCart] = useState(false);
  const [invalidSkus, setInvalidSkus] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    const orderDetails = localStorage.getItem("orderDetails");
    if (orderDetails) {
      const obj = JSON.parse(orderDetails);
      dispatch(store_addr_details(obj));
    }
  }, []);

  console.log({ table });

  useEffect(() => {
    if (table?.rows?.length > 0) {
      let skus = [];
      table.rows.forEach((element) => {
        if (element[1] && element[2] && parseInt(element[3])) {
        } else {
          skus.push(element[0]);
        }
      });
      setInvalidSkus(skus);
    }
  }, [table]);

  return (
    <div className="m2 claim-card p1 pl2 bulk-order">
      <span className="close">
        <img
          src={Close}
          alt="close"
          width={15}
          onClick={() => {
            history.push("/shop-for-tyres");
          }}
        />
      </span>
      <h3
        style={{
          marginBottom: 20,
        }}
      >
        Create Bulk Order - Preview (Total quantity -{" "}
        {table?.rows?.reduce((prev, curr) => {
          return prev + (curr[5] ? parseFloat(curr[5]) : 0);
        }, 0)}
        )
      </h3>
      <div
        style={{
          display: "flex",
          gap: "20px",
        }}
      >
        <div className="d-flex">
          <div style={{ overflowX: "auto" }}>
            <div className="table">
              {/* <div className="t-wrap"> */}
              <div className="thead">
                <div className="tr">
                  {table?.cols?.map((ele, idx) =>
                    idx === 6 ? null : (
                    <div
                      key={idx}
                      className="td"
                      style={{ width: `${(ele?.width || 10)}rem` }}
                    >
                      {ele?.replace(/_/g, " ")}
                    </div>
                  )
                )}
                <div className="td">Status</div>
              </div>
            </div>
            <div className="tbody">
              {table?.rows?.length === 0 ? (
                <div className="tr flex-center mt1 mb1">No Products</div>
              ) : (
                table?.rows?.map((item, idx) => (
                  <div className="tr" key={idx}>
                    {item?.map((ele, index) =>
                      index === 6 ? null : (
                        <div
                          key={index}
                          className="td"
                          style={{ width: "10rem" }}
                        >
                          {index === 5 ? (
                            <input
                              defaultValue={ele}
                              style={{ width: "8rem" }}
                              onChange={(e) => {
                                  if (Number.isNaN(Number(e.target.value))) {
                                    return;
                                  }
                                const tbs = { ...table };
                                tbs.rows[idx][index] = e.target.value;
                                setTable(tbs);
                              }}
                            />
                          ) : (
                            ele
                          )}
                        </div>
                      )
                    )}
                    <div className="td">
                      {Array.isArray(skuRes) &&
                      skuRes?.find((s) => s.sku === item[0])
                        ? skuRes?.find((s) => s.sku === item[0])?.status
                        : invalidSkus?.includes(item[0])
                        ? " Failed to Add."
                        : ""}
                    </div>
                    {!addedToCart && (
                    <div className="td" style={{ width: "5rem" }}>
                      <img
                      className="cancel"
                      src={Close}
                      alt="delete"
                      width={14}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // STEP 1 — DELETE FROM UI ALWAYS
                        const updated = { ...table };
                        updated.rows = updated.rows.filter((_, i) => i !== idx);
                        setTable(updated);
                      }}
                    />
                    </div>
                  )}
                  </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
        <ContainerStatus
          fromBulk
          table={table}
          order_type={stored_details?.order_type}
          showFooter
        />
      </div>

      <div className="mt1">
        <button
          className="cancel-btn mr2"
          onClick={() => {
            setPreview(false);
          }}
        >
          Back
        </button>
        <button
          className="primary-btn"
          disabled={loading}
          onClick={() => {
            setLoading(true); //start processing
            let obj = {
              ...stored_details,
              order_type: stored_details?.vtweg === "41" ? "FTL" : "FD",
              email: localStorage.getItem("email"),
            };
            if (addedToCart) {
              history.push("/cart");
              return;
            }
            if (localStorage.getItem("cartId")) {
              obj.cart_id = localStorage.getItem("cartId");
            }

            let arr = [];
            table?.rows?.forEach((ele) => {
              if (invalidSkus.includes(ele[0]) === false) {
                arr.push({
                  sku: ele[0],
                  quantity: ele[5],
                  oepregion: ele[1],
                });
              }
            });
            endpoint
              .post(apis.bulk_order, {
                ...obj,
                products: arr?.filter((ele) => ele.quantity > 0),
              })
              .then((res) => {
                localStorage.setItem("cartId", res?.data?.cart_id);
                setSKURes(res.data?.cart_status);
                setAddedToCart(true);
                toast.success("Bulk order successful.");
              })
              .catch((err) => {
                toast.error(err?.response?.data?.message);
              })
              .finally(() => {
                setLoading(false); //stop processing
              });
          }}
        >
          {loading ? "Processing..." : addedToCart ? "Go To Cart" : "Add to Cart"}
        </button>
      </div>
    </div>
  );
};

export default BulkPreview;
